import React from 'react'

const ClientSection = () => {
  return (

    <section id="clients" class="clients">
    <div class="container" data-aos="zoom-in">
    <div class="section-title">
    <h2>We repairs all device from major brand!</h2>
    </div>
      <div class="clients-slider swiper">
        <div class="swiper-wrapper align-items-center">
          <div class="swiper-slide"><img src="assets/img/clients/dell.jpeg" class="img-fluid" alt=""/></div>
          <div class="swiper-slide"><img src="assets/img/clients/hp.jpeg" class="img-fluid" alt=""/></div>
          <div class="swiper-slide"><img src="assets/img/clients/lenovo.jpeg" class="img-fluid" alt=""/></div>
          <div class="swiper-slide"><img src="assets/img/clients/toshiba.jpg" class="img-fluid" alt=""/></div>
          <div class="swiper-slide"><img src="assets/img/clients/apple.jpeg" class="img-fluid" alt=""/></div>
          <div class="swiper-slide"><img src="assets/img/clients/sony.jpeg" class="img-fluid" alt=""/></div>
          <div class="swiper-slide"><img src="assets/img/clients/acer.jpeg" class="img-fluid" alt=""/></div>
          <div class="swiper-slide"><img src="assets/img/clients/asus.jpeg" class="img-fluid" alt=""/></div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </section>
  )
}

export default ClientSection;
